<div #zControl class="isMobile">
    <div class="zoom-control" id="zoom-control" (click)="openControl()">
        <div class="zoom-content">Zoom Control <i class="prime fa fa-search-plus"></i></div>
    </div>

    <div class="zoom-control-box" [hidden]="!showControl">
        <div class="z-control-header">Zoom Control</div>
        <div class="z-control-subtext">
            Looks like you are using <b>{{ DPR }}%</b> scaling.
            <span *ngIf="DPR !== 100">For best experience, try adjusting your zoom level.</span>
        </div>
        <div class="z-control">
            <button (click)="decreaseZoom()" class="control">
                <span><i class="fa fa-minus"></i></span>
            </button>
            <button class="current-device-pixel">
                <span>{{ zoomPercentage }}%</span>
            </button>
            <button (click)="increaseZoom()" class="control">
                <span><i class="fa fa-plus"></i></span>
            </button>
        </div>
    </div>
</div>
